"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Gated.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _Spinner = require('web/components/Spinner');



/* Renders children once Forms is on; with it off, lands on Chats. */
const Gated = ({ gate, children }) => {
  if (gate === 'loading') return _react2.default.createElement('div', { className: "forms-loading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 11}} ))
  if (gate !== 'on') return _react2.default.createElement(_reactrouterdom.Redirect, { to: _routes2.default.INBOX.ROOT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}} )
  return _react2.default.createElement(_react2.default.Fragment, null,  children )
}

exports. default = Gated
